<template>
  <el-dialog
    v-drag
    title="权限分配"
    :visible.sync="dialogVisible"
    width="840px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5%"
  >
    <span slot="title">
      <img src="@/assets/images/system/company.png" />成员调度
    </span>
    <div class="content">
      <div class="right">
        <div class="title">未加入公司</div>
        <BaseTable
          :height="500"
          :tableData="tableData"
          :isPager="false"
          @handleSelectionChange="rightSelectionChange"
        >
        </BaseTable>
      </div>
      <div class="arrow_content">
        <div title="向右移动并加入公司" class="arrow flex_c_c" @click="right">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div title="向左移动并移除公司" class="arrow flex_c_c" @click="left">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>
      <div class="left">
        <div class="title">已加入公司</div>
        <BaseTable
          :height="500"
          :tableData="tableData1"
          :isPager="false"
          @handleSelectionChange="leftSelectionChange"
        >
        </BaseTable>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel" @click="cancel">取 消</div>
      <div class="ok" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
// import {
//   getUserRoleAssignedPermission,
//   getUserRoleUnassignedPermission,
//   grantPermission
// } from '@/api/setting'
import {
  getUserUnjoinCompanyList,
  getUserJoinCompanyList,
  assignUserCompany
} from '@/api/system'

const BaseTable = () => import('@/components/table/BaseTable')
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'label',
            label: '公司/子公司',
            width: ''
          }
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      tableData1: {
        fileds: [
          {
            filed: 'label',
            label: '公司/子公司',
            width: ''
          }
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      rightSelection: [],
      leftSelection: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      try {
        const res = await getUserUnjoinCompanyList({
          userId: this.rowData.userId
        })
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
        const res1 = await getUserJoinCompanyList({
          userId: this.rowData.userId
        })
        if (res1.success) {
          this.tableData1.columns = res1.data
        } else {
          this.$message.error(res1.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async ok() {
      //   this.$emit('ok')
      // if (this.tableData1.le)
      const companyIds = this.tableData1.columns.map((a) => a.value)
      try {
        const res = await assignUserCompany({
          userId: this.rowData.userId,
          companyIds
        })
        if (res.success) {
          this.$message.success('设置成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    rightSelectionChange(items) {
      this.rightSelection = items
    },
    right() {
      this.tableData1.columns = [
        ...this.tableData1.columns,
        ...this.rightSelection
      ]
      this.tableData.columns = this.tableData.columns.filter((a) => {
        return this.rightSelection.indexOf(a) === -1
      })
    },
    leftSelectionChange(items) {
      this.leftSelection = items
    },
    left() {
      this.tableData.columns = [
        ...this.tableData.columns,
        ...this.leftSelection
      ]
      this.tableData1.columns = this.tableData1.columns.filter((a) => {
        return this.leftSelection.indexOf(a) === -1
      })
    }
  }
}
</script>
<style scoped lang="less">
.content {
  width: calc(100% - 40px);
  height: 680px;
  display: flex;
  max-height: 550px;
  margin: 0 auto;
}
.right {
  width: 45%;
  height: 100%;
  overflow: auto;
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
.arrow_content {
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.arrow_content div {
  margin: 10px 0;
}
.left {
  width: 45%;
  height: 100%;
  overflow: auto;
  border: 1px solid #eeeeee;
  border-radius: 5px;
}
.title {
  text-align: center;
  color: #303133;
  line-height: 53px;
  height: 53px;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  border-bottom: 1px solid #eeeeee;
}
.arrow {
  width: 40px;
  height: 40px;
  font-size: 20px;
  border: 1px solid #eeeeee;
  border-radius: 4px 4px 4px 4px;
  color: #666666;
  box-sizing: border-box;
}
.arrow:hover {
  color: #409eff;
  border: 1px solid #409eff;
  cursor: pointer;
}
.footers {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
